import React, {useState} from 'react';
import TBInput from "./Input.react";
import styled from "styled-components"
import {Icon} from "react-materialize";
import propTypes from 'prop-types';

const StyledSearch = styled.div`
  display: flex;
  align-items: center;
  width: 30rem;
  
  .tb-inside-input {
    color: white;
  }
  
  input[type=search]:not(.browser-default) {
    font-size: 2rem;
    border-bottom: 1px solid ${(props) => props.darkMode ? 'white' : 'black'};
    ::placeholder {
      ${(props) => props.darkMode && 'color: white'};
    }
    &:hover, &:active, &:focus {
      box-shadow: none;
      border-bottom: 1px solid ${(props) => props.darkMode ? 'white' : '#9e9e9e'};
    }
  }
  
  &:hover, &:focus-within {
    -webkit-transition : color 600ms ease-out;
    -moz-transition : color 600ms ease-out;
    -o-transition : color 600ms ease-out;
    transition : color 600ms ease-out;
    
    i {
      color: ${(props) => props.darkMode ? 'white' : '#07bb9c'};
    }
    
    .close {
      color: darkred;
    }
  }
  
  i {
    font-size: 2.8rem;
    padding-right: .5rem;
    cursor: pointer;
    color: ${(props) => props.darkMode ? 'white' : 'black'};
  }
  
  .tb-input {
    width: 30rem;
  }
  
  .tb-inside-input {
    padding-bottom: 6px;
  }
`

const TBSearch = ({handleSearch, placeHolder = 'Search', darkMode=false}) => {
  const [search, setSearch] = useState('');
  const [searched, setClearSearch] = useState(false)

  const handleChange = (event) => {
    setSearch(event.target.value);
  }

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleClick();
    }
  }

  const handleClick = () => {
    if (search.length > 0) {
      setClearSearch(true);
      handleSearch(search);
    }
  }

  const handleClear = () => {
    setSearch('');
    setClearSearch(false);
    handleSearch('CLEAR_SEARCH');
  }

  return (
    <StyledSearch darkMode={darkMode}>
      <TBInput onKeyDown={handleKeyDown} type={'search'} className={'search-input'} placeholder={placeHolder} value={search} handleChange={handleChange}/>
      {
        searched ? <Icon className={'close'} onClick={handleClear}>close</Icon> : <Icon onClick={handleClick}>search</Icon>
      }
    </StyledSearch>
  )
}

TBSearch.propTypes = {
  handleSearch: propTypes.func
}

export default TBSearch;